// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"cb54b0b0","267":"477c6563","315":"65f779f7","631":"80885088"}[chunkId] + ".chunk.css";
};